<template>
  <div>
    <estimate-of-repairs-category
      title="0. Soft Costs"
      :total-function="getCategoryTotal('softCosts')"
      :schema="schemaDefinition.softCosts.schema"
      :options="schemaDefinition.softCosts.formOptions"
      :model="model.softCosts"
      :isDraw="isDraw"
      name="softCostsForm"
      ref="softCostsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'softCosts')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="1. General Requirements"
      :total-function="getCategoryTotal('generalRequirements')"
      :schema="schemaDefinition.generalRequirements.schema"
      :options="schemaDefinition.generalRequirements.formOptions"
      :model="model.generalRequirements"
      :isDraw="isDraw"
      name="generalRequirementsForm"
      ref="generalRequirementsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'generalRequirements')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="2. Site Construction"
      :total-function="getCategoryTotal('siteConstruction')"
      :schema="schemaDefinition.siteConstruction.schema"
      :options="schemaDefinition.siteConstruction.formOptions"
      :model="model.siteConstruction"
      :isDraw="isDraw"
      name="siteConstructionForm"
      ref="siteConstructionForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'siteConstruction')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="3. Concrete"
      :total-function="getCategoryTotal('concrete')"
      :schema="schemaDefinition.concrete.schema"
      :options="schemaDefinition.concrete.formOptions"
      :model="model.concrete"
      :isDraw="isDraw"
      name="concreteForm"
      ref="concreteForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'concrete')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="4. Masonry"
      :total-function="getCategoryTotal('masonry')"
      :schema="schemaDefinition.masonry.schema"
      :options="schemaDefinition.masonry.formOptions"
      :model="model.masonry"
      :isDraw="isDraw"
      name="masonryForm"
      ref="masonryForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'masonry')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="5. Metals"
      :total-function="getCategoryTotal('metals')"
      :schema="schemaDefinition.metals.schema"
      :options="schemaDefinition.metals.formOptions"
      :model="model.metals"
      :isDraw="isDraw"
      name="metalsForm"
      ref="metalsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'metals')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="6. Woods &amp; Plastics"
      :total-function="getCategoryTotal('woodsPlastics')"
      :schema="schemaDefinition.woodsPlastics.schema"
      :options="schemaDefinition.woodsPlastics.formOptions"
      :model="model.woodsPlastics"
      :isDraw="isDraw"
      name="woodsPlasticsForm"
      ref="woodsPlasticsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'woodsPlastics')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="7. Thermal &amp; Moisture Protection"
      :total-function="getCategoryTotal('thermalMoistureProtection')"
      :schema="schemaDefinition.thermalMoistureProtection.schema"
      :options="schemaDefinition.thermalMoistureProtection.formOptions"
      :model="model.thermalMoistureProtection"
      :isDraw="isDraw"
      name="thermalMoistureProtectionForm"
      ref="thermalMoistureProtectionForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'thermalMoistureProtection')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="8. Doors &amp; Windows"
      :total-function="getCategoryTotal('doorsWindows')"
      :schema="schemaDefinition.doorsWindows.schema"
      :options="schemaDefinition.doorsWindows.formOptions"
      :model="model.doorsWindows"
      :isDraw="isDraw"
      name="doorsWindowsForm"
      ref="doorsWindowsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'doorsWindows')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="9. Finishes"
      :total-function="getCategoryTotal('finishes')"
      :schema="schemaDefinition.finishes.schema"
      :options="schemaDefinition.finishes.formOptions"
      :model="model.finishes"
      :isDraw="isDraw"
      name="finishesForm"
      ref="finishesForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'finishes')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="10. Specialties"
      :total-function="getCategoryTotal('specialties')"
      :schema="schemaDefinition.specialties.schema"
      :options="schemaDefinition.specialties.formOptions"
      :model="model.specialties"
      :isDraw="isDraw"
      name="specialtiesForm"
      ref="specialtiesForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'specialties')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="11. Equipment"
      :total-function="getCategoryTotal('equipment')"
      :schema="schemaDefinition.equipment.schema"
      :options="schemaDefinition.equipment.formOptions"
      :model="model.equipment"
      :isDraw="isDraw"
      name="equipmentForm"
      ref="equipmentForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'equipment')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="12. Furnishings"
      :total-function="getCategoryTotal('furnishings')"
      :schema="schemaDefinition.furnishings.schema"
      :options="schemaDefinition.furnishings.formOptions"
      :model="model.furnishings"
      :isDraw="isDraw"
      name="furnishingsForm"
      ref="furnishingsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'furnishings')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="13. Special Construction"
      :total-function="getCategoryTotal('specialConstruction')"
      :schema="schemaDefinition.specialConstruction.schema"
      :options="schemaDefinition.specialConstruction.formOptions"
      :model="model.specialConstruction"
      :isDraw="isDraw"
      name="specialConstructionForm"
      ref="specialConstructionForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'specialConstruction')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="14. Conveying Systems"
      :total-function="getCategoryTotal('conveyingSystems')"
      :schema="schemaDefinition.conveyingSystems.schema"
      :options="schemaDefinition.conveyingSystems.formOptions"
      :model="model.conveyingSystems"
      :isDraw="isDraw"
      name="conveyingSystemsForm"
      ref="conveyingSystemsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'conveyingSystems')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="15. Mechanical Systems"
      :total-function="getCategoryTotal('mechanicalSystems')"
      :schema="schemaDefinition.mechanicalSystems.schema"
      :options="schemaDefinition.mechanicalSystems.formOptions"
      :model="model.mechanicalSystems"
      :isDraw="isDraw"
      name="mechanicalSystemsForm"
      ref="mechanicalSystemsForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'mechanicalSystems')">
    </estimate-of-repairs-category>

    <estimate-of-repairs-category
      title="16. Electrical"
      :total-function="getCategoryTotal('electrical')"
      :schema="schemaDefinition.electrical.schema"
      :options="schemaDefinition.electrical.formOptions"
      :model="model.electrical"
      :isDraw="isDraw"
      name="electricalForm"
      ref="electricalForm"
      v-on:total-changed="(total) => updateCategoryTotal(total, 'electrical')">
    </estimate-of-repairs-category>

    <b-row class="mt-5">
      <b-col>
        <vue-form-generator
          :schema="descriptionSchema.schema"
          :options="descriptionSchema.formOptions"
          :model="model"
          ref="descriptionForm"
        />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col>
        <b-card>
          <b-row>
            <b-col><span class="h4 float-left">TOTAL SOFT COSTS:</span></b-col>
            <b-col><span class="h4 float-right">{{ formatedSoftCostsTotal }}</span></b-col>
          </b-row>
          <b-row>
            <b-col><span class="h4 float-left">TOTAL HARD COSTS:</span></b-col>
            <b-col><span class="h4 float-right">{{ hardCostsTotal }}</span></b-col>
          </b-row>
          <b-row v-if="this.isChangeOrder">
            <b-col><span class="h4 float-left">REMAINING BALANCE:</span></b-col>
            <b-col><span class="h4 float-right">{{ remainingBalance }}</span></b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col><span class="h3 float-left">TOTAL PROJECT COSTS:</span></b-col>
            <b-col><span class="h3 float-right">{{ totalOfRepairs }}</span></b-col>
          </b-row>
          <b-row v-if="error">
            <b-col>
              <span class="text-small text-danger">{{ error }}</span>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import helper from '@/libs/helper';
import numbro from 'numbro';

import VueFormGenerator from 'vue-form-generator';
import EstimateOfRepairsCategory from '@/components/my_deals/actions/estimate_of_repairs/EstimateOfRepairsCategory';

import EOR_SCHEMA from '@/components/my_deals/actions/estimate_of_repairs/resources/schema';
import EOR_MODEL from '@/components/my_deals/actions/estimate_of_repairs/resources/model.json';


export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    EstimateOfRepairsCategory,
  },
  props: {
    isDraw: Boolean,
    isChangeOrder: {
      type: Boolean,
      default() { return false; },
    },
    loan: null,
  },
  data() {
    return {
      schemaDefinition: EOR_SCHEMA,
      model: helper.copy(EOR_MODEL),
      lastReport: null,
      forms: [
        'softCostsForm',
        'generalRequirementsForm',
        'siteConstructionForm',
        'concreteForm',
        'masonryForm',
        'metalsForm',
        'woodsPlasticsForm',
        'thermalMoistureProtectionForm',
        'doorsWindowsForm',
        'finishesForm',
        'specialtiesForm',
        'equipmentForm',
        'furnishingsForm',
        'specialConstructionForm',
        'conveyingSystemsForm',
        'mechanicalSystemsForm',
        'electricalForm',
      ],
      error: null,
    };
  },
  methods: {
    getCategoryTotal(categoryName) {
      if (!this.isDraw) {
        const total = parseFloat(this.model[categoryName].total);
        if (total > 0.00) {
          return total;
        }
      }
      const items = Object.keys(this.model[categoryName]).filter(item => item !== 'balance');
      const itemsValues = items.map(
        itemName => (parseFloat(this.model[categoryName][itemName])) || 0);
      return itemsValues.reduce((sum, value) => sum + value, 0.00);
    },
    getTotal(excludentCategories) {
      const itemsValues = [];
      const innerExcludentCategories = !excludentCategories ? [] : excludentCategories;
      Object.keys(this.model).forEach((categoryName) => {
        if (typeof this.model[categoryName] === 'object' && !innerExcludentCategories.includes(categoryName)) {
          Object.keys(this.model[categoryName]).forEach((key) => {
            if (key !== 'balance') {
              itemsValues.push(parseFloat(this.model[categoryName][key]) || 0);
            }
          });
        }
      });
      return itemsValues.reduce((sum, value) => sum + value, 0.00);
    },
    updateCategoryTotal(total, categoryName) {
      const category = helper.copy(EOR_MODEL[categoryName]);
      category.total = parseFloat(total);
      this.$set(this.model, categoryName, category);
    },
    reset() {
      this.forms.forEach((form) => {
        if (this.$refs[form]) {
          this.$refs[form].reset();
        }
      });
      this.model = helper.copy(EOR_MODEL);
    },
    validate() {
      if (this.isChangeOrder) {
        if ((numbro(this.totalOfRepairs) > this.loan.holdback_balance)) {
          this.error = 'The total cost of repairs should not be greater than Holdback Balance.';
          return false;
        }
      }
      if (numbro(this.totalOfRepairs) > 0) {
        let valid = this.$refs.descriptionForm.validate();
        this.forms.forEach((form) => {
          if (this.$refs[form]) {
            valid = valid && this.$refs[form].validate();
          }
        });

        this.error = null;
        return valid;
      }

      this.error = 'The total cost of repairs should be greater than $ 0.00';
      return false;
    },
    setBalance(value) {
      if (value) {
        Object.keys(value).forEach((key) => {
          this.$set(this.model[key], 'balance', parseFloat(value[key].balance));
        });
      }
    },
  },
  computed: {
    descriptionSchema() {
      return this.isDraw ? this.schemaDefinition.access : this.schemaDefinition.description;
    },
    formatedSoftCostsTotal() {
      let result = this.getCategoryTotal('softCosts');
      result = numbro(result).formatCurrency({ thousandSeparated: true, mantissa: 2 });
      return result;
    },
    hardCostsTotal() {
      let result = this.getTotal(['softCosts', 'description']);
      result = numbro(result).formatCurrency({ thousandSeparated: true, mantissa: 2 });
      return result;
    },
    totalOfRepairs() {
      let result = this.getTotal(['description']);
      result = numbro(result).formatCurrency({ thousandSeparated: true, mantissa: 2 });
      return result;
    },
    remainingBalance() {
      const result = this.loan.holdback_balance - numbro(this.totalOfRepairs);
      return numbro(result).formatCurrency({ thousandSeparated: true, mantissa: 2 });
    },
  },
};
</script>

<style>
.document-card {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/my_deals/actions/estimate_of_repairs/EstimateOfRepairs.vue